import { connectSearchBox } from 'react-instantsearch-core';
import VoiceSearch from '../components/VoiceSearch';
export default connectSearchBox(VoiceSearch);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch-dom/dist/es/widgets/VoiceSearch.js
// module id = 838
// module chunks = 0